import { resolveListPickerTranslationKey } from './listPickerTranslationKeyResolver';

export function ListPickerBoxConstructor(services, type) {

  const joint = services.joint;

  return joint.shapes.html.AbstractBoxWithInPort.extend({
    defaults: joint.util.deepSupplement({
      'labelText': services.$translate.instant(resolveListPickerTranslationKey(type, 'box_name_in_diagram')),
      'labelFill': '#3977e4',
      'type': type
    }, joint.shapes.html.AbstractBoxWithInPort.prototype.defaults)
  });
}
